import { useState } from "react";
import { Upload } from "lucide-react";
import BulkUploadDeals from "../deals/BulkUploadDeals";

export default function BulkUploadTab() {
  const [show, setShow] = useState(false);

  return (
    <div className="rounded-xl border border-gray-100 bg-white shadow-sm p-6">
      <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2">
        Bulk Upload Deals
      </h2>
      <p className="text-sm text-gray-500 mb-4 max-w-2xl">
        Upload many deals at once from a spreadsheet (.xls or .xlsx). Each row
        becomes a draft deal you can review before approving into the pipeline.
      </p>
      <button
        type="button"
        onClick={() => setShow(true)}
        className="inline-flex items-center gap-2 rounded-md bg-[#1E293B] text-white px-4 py-2 text-sm font-medium hover:opacity-90 transition"
      >
        <Upload size={14} /> Open Bulk Uploader
      </button>
      {show && <BulkUploadDeals onClose={() => setShow(false)} />}
    </div>
  );
}
